import type { FC } from 'react'
import styled from '@emotion/styled'

import sanitizeHtml from 'sanitize-html'

import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import DemoForm from '@segment/templates/Forms/DemoForm'

interface HeroProps {
  heading: string
  copy: {
    paragraph: string
  }[]
  formId: string
}
const Hero: FC<HeroProps> = ({ heading, copy, formId }) => {
  return (
    <Wrapper>
      <StyledHeroRecipeBase variant="2Col" copyVariant="wide">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Heading tag="h1" variant="h1">
              {heading}
            </CopyText.Heading>
            {copy.map((text, index) => (
              <CopyText.Description
                key={index}
                tag="p"
                variant="pExtraLarge"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(text.paragraph, { allowedTags: [`a`] }),
                }}
              />
            ))}
          </CopyTextBase>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <FormWrapper>
            <DemoForm customFormIdentifier={formId} customTrackingType={formId} successMessageAppearance="light" />
          </FormWrapper>
        </HeroRecipe.Contents>
      </StyledHeroRecipeBase>
    </Wrapper>
  )
}

export default Hero

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledHeroRecipeBase = styled(HeroRecipeBase)`
  ${HeroRecipe.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      align-items: start;
    }
    ${({ theme }) => theme.breakpoints.up(`xl`)} {
      grid-template-columns: minmax(50%, 640px) minmax(50%, 640px);
    }
  }
`

const FormWrapper = styled.div`
  max-width: 417px;
  width: 100%;
`
